<template>
  <ul class="progressbar">
    <li :class="{active: progress >= 1, current: progress == 1}">Get Started</li>
    <li :class="{active: progress >= 2, current: progress == 2}">Company Details</li>
    <li :class="{active: progress >= 3, current: progress == 3}">Work readiness</li>
    <li :class="{active: progress >= 4, current: progress == 4}">Preview</li>
  </ul>
</template>

<script>
export default {
  props: {
    progress: {
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.progressbar {
  list-style: none;
  display: contents;
}

.progressbar li {
  float: left;
  width: 25%;
  position: relative;
  text-align: center;
}

.progressbar li:before {
  content: "";
  width: 30px;
  height: 30px;
}

.progressbar li:before {
  content: "";
  width: 30px;
  height: 30px;
  border: 2px solid #0db4e6;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}

.progressbar {
  counter-reset: step;
}

.progressbar li:before {
  content: "";
  counter-increment: step;
  width: 30px;
  height: 30px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}

.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 4px;
  background: #d5d5d5;
  top: 15px;
  left: -50%;
  z-index: -1;
}

.progressbar li:first-child:after {
  content: none;
}

.progressbar li.active.current:before {
  content: "";
  width: 30px;
  height: 30px;
  border: 2px solid #0db4e6;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
}

.progressbar li.active:before {
  border-color: #2ecc71;
  background: #2ecc71;
  color: white;
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  content: "\F00C";
}

li {
  color: #313131;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  text-align: center;
}
</style>
